export var AreaTaxaEnum;
(function (AreaTaxaEnum) {
    AreaTaxaEnum["ATE_250"] = "ATE_250";
    AreaTaxaEnum["ENTRE_250_A_1000"] = "ENTRE_250_A_1000";
    AreaTaxaEnum["ACIMA_1000"] = "ACIMA_1000";
})(AreaTaxaEnum || (AreaTaxaEnum = {}));
(function (AreaTaxaEnum) {
    AreaTaxaEnum.mapDescricao = new Map([
        [AreaTaxaEnum.ATE_250, 'Área de até 250 hectares'],
        [AreaTaxaEnum.ENTRE_250_A_1000, 'Área de 250 hectares até 1.000 hectares'],
        [AreaTaxaEnum.ACIMA_1000, 'Área acima de 1.000 hectares'],
    ]);
    function getDescricao(key) {
        return AreaTaxaEnum.mapDescricao.get(key);
    }
    AreaTaxaEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        AreaTaxaEnum.mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    AreaTaxaEnum.getOptions = getOptions;
})(AreaTaxaEnum || (AreaTaxaEnum = {}));
